import i18n from "../i18n";
import { getTld } from "@/utils/urlHelper.ts";

export const getTitlePrefix = (): string => {
  if (import.meta.env.VITE_TITLE_PREFIX) {
    return import.meta.env.VITE_TITLE_PREFIX;
  }

  return `Ersties.${getTld()}`;
};

export const getTitle = (text: string | null = null, withPrefix: boolean = true) => {
  if (!withPrefix) {
    // eslint-disable-next-line
    // @ts-ignore
    return i18n.global.t(text);
  }

  if (!text) {
    return getTitlePrefix();
  }

  // eslint-disable-next-line
  // @ts-ignore
  return `${getTitlePrefix()} - ${i18n.global.t(text)}`;
};
